import api from '../context/AxiosAPI'
import {INIT_ROUTE, OLD_RACES} from './routes';
import {
    CLEAR,
    CLEAR_FAILED, CLEAR_SUCCESSFUL, GET_OLD_RACES, GET_OLD_RACES_FAILED, GET_OLD_RACES_SUCCESSFUL,
    INIT_FAILED,
    INIT_SUCCESSFUL,
    INITIALIZE,
    SEARCH,
    SEARCH_FAILED,
    SEARCH_SUCCESSFUL
} from './types';
import {RACES, SEARCH as SEARCH_ROUTE} from './routes';

export const initialize = async (dispatch) => {
    dispatch({
        type: INITIALIZE
    })
    try {
        const data = await api.get(INIT_ROUTE)
        dispatch({
            type: INIT_SUCCESSFUL,
            payload: {
                response: [...data.data.response]}
        })
    } catch (e) {
        dispatch({
            type: INIT_FAILED,
            payload: {
                error: e
            }
        })
    }
}

export const searchTable = async (dispatch, raceId, name, active) => {
    dispatch({
        type: SEARCH,
        payload: {
            race: raceId
        }
    })
    try {
        const data = await api.get(`${RACES}/${raceId}${SEARCH_ROUTE}${name}`)
        dispatch({
            type: SEARCH_SUCCESSFUL,
            payload: {
                race: raceId,
                active: active,
                type: data.data.type,
                results: data.data.response
            }
        })
    } catch(e) {
        dispatch({
            type: SEARCH_FAILED,
            payload: {
                race: raceId,
                active: active
            }
        })
    }
}

export const clearSearchTable = (dispatch, id, active) => {
    dispatch({
        type: CLEAR,
        payload: {
            race: id
        }
    })
    try {
        dispatch({
            type: CLEAR_SUCCESSFUL,
            payload: {
                race: id,
                active: active
            }
        })
    } catch(e) {
        dispatch({
            type:CLEAR_FAILED,
            payload: {
                race: id,
                active: active
            }
        })
    }
}

export const getOldRaces = async (dispatch) => {
    dispatch({
        type: GET_OLD_RACES
    })
    try {
        const data = await api.get(OLD_RACES)
        dispatch({
            type: GET_OLD_RACES_SUCCESSFUL,
            payload: {
                response: [...data.data.response]}
        })
    } catch (e) {
        dispatch({
            type: GET_OLD_RACES_FAILED,
            payload: {
                error: e
            }
        })
    }
}